.rule-import2 {
	background: lightgreen;
}


/** WEBPACK FOOTER **
 ** ./loaders/_css/~/resources-module/stylesheet-import2.css
 **/